import React from 'react'

function FaqIcon(props) {
   return (
      <svg
         xmlns="http://www.w3.org/2000/svg"
         width="26.139"
         height="30.752"
         viewBox="0 0 26.139 30.752"
         {...props}
      >
         <path
            fill={props.color}
            id="contact_support_FILL0_wght400_GRAD0_opsz48"
            d="M135.184,206.752l-.384-4.228h-1.538a13.262,13.262,0,1,1,5.132-25.543,12.287,12.287,0,0,1,4.055,2.748,12.818,12.818,0,0,1,2.71,4.171,13.759,13.759,0,0,1,.98,5.247,17.829,17.829,0,0,1-.75,5.074,19.981,19.981,0,0,1-2.172,4.843,21.773,21.773,0,0,1-3.46,4.267A23.409,23.409,0,0,1,135.184,206.752Zm1.922-4.152a19.37,19.37,0,0,0,4.94-6.246,16.056,16.056,0,0,0,1.787-7.207,10.674,10.674,0,0,0-2.979-7.8,10.086,10.086,0,0,0-7.515-3.037,10.956,10.956,0,1,0-.077,21.911h3.844Zm-3.767-4.421a1.444,1.444,0,1,0-1.038-.423A1.411,1.411,0,0,0,133.339,198.18Zm-1.038-5.228h1.922a3.466,3.466,0,0,1,.327-1.6,7.669,7.669,0,0,1,1.365-1.672,7.485,7.485,0,0,0,1.461-1.9,4.188,4.188,0,0,0,.423-1.864,3.754,3.754,0,0,0-1.172-2.845,4.359,4.359,0,0,0-3.133-1.115,5.056,5.056,0,0,0-4.767,3.152l1.768.73a3.146,3.146,0,0,1,1.172-1.48,3.1,3.1,0,0,1,1.711-.48,2.7,2.7,0,0,1,1.807.557,1.848,1.848,0,0,1,.653,1.48,3,3,0,0,1-.423,1.48,10.026,10.026,0,0,1-1.5,1.864,6.849,6.849,0,0,0-1.326,1.73A5.092,5.092,0,0,0,132.3,192.952ZM133.07,190.453Z"
            transform="translate(-120 -176)"
         />
      </svg>
   )
}

export default FaqIcon
